import type { ResourceTypeToSecurityGroup } from '@repo/api-gw-sdk';

export const cloudAccountConfigurationAwsResourceTypes: (keyof ResourceTypeToSecurityGroup)[] =
  ['restoreServer', 'restoredRdsInstance'];

export const cloudAccountConfigurationAwsResourceTypesTitles: Record<
  (typeof cloudAccountConfigurationAwsResourceTypes)[number],
  string
> = {
  restoreServer: 'Restore server',
  restoredRdsInstance: 'Restored RDS instance',
};
